// extracted by mini-css-extract-plugin
module.exports = {"root":"Actions_root__BXVW3","actionMinWidth":"Actions_actionMinWidth__weT6C"};